import React from "react"
import axios from "axios"
import AppStore from "../AppStore"
import {observer} from "mobx-react"
import { Redirect } from "react-router-dom";

function centeredPopup(url,winName,w,h,scroll){
let LeftPosition = (screen.width) ? (screen.width-w)/2 : 0;
let TopPosition = (screen.height) ? (screen.height-h)/2 : 0;
let settings =
'height='+h+',width='+w+',top='+TopPosition+',left='+LeftPosition+',scrollbars='+scroll+',resizable'
var popupWindow = window.open(url,winName,settings)
}
@observer
class PayLink extends React.Component {
  calculateState(){
    axios.post("/api/v1/experts/app/lienspaiements",{id: AppStore.rdv.id}).then((data)=>{
        if(data.data.liens.length==0){
          this.setState({redirect: true})
        }else{
        this.setState({
          liens: data.data.liens,
          montant: data.data.montant,
          loaded: true
        })
      }
    })

  }
  componentDidMount(){
    M.updateTextFields();
  }

  constructor(props) {
    super(props);
    this.calculateState = this.calculateState.bind(this);
    this.openPopUP = this.openPopUP.bind(this);
    this.state = {
      liens: [],
      loaded: false
    };
    this.calculateState()
  }
  openPopUP(e){
    let lien = e.target.dataset.lien
    centeredPopup(lien,'Paiement','900','700','yes')

  }
  render () {
    if(this.state.redirect==true){
      {return(<Redirect to="/Signatures" />)}
    }
    if(!this.state.loaded){
      return(
      <React.Fragment>
      <h1 className="center">Chargement en cours des données du serveurs</h1>
      </React.Fragment>

        )
    }else{
      return (
        <React.Fragment>
        <h1 className="center">Paiement des surs couts</h1>
        <p>Montant total payé : {this.state.montant}€</p>
        <h3>A payer</h3>
        <table className="striped bordered">
          <tbody>
            <tr>
              <th>montant</th>
              <th>Titre</th>
              <th>nom</th>
              <th>lien</th>
            </tr>
            {this.state.liens.map((paiement,index)=>(
                <tr key={index}>
                  <td>{paiement.price}€</td>
                  <td>{paiement.titre}</td>
                  <td>{paiement.nom}</td>
                  <td onClick={this.openPopUP} data-lien={paiement.lien}>GO Paiement</td>
                </tr>
              ))}
          </tbody>
        </table>
        </React.Fragment>
      );
    }
  }
}

export default PayLink
